// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"ba642142","449":"0d2444bd","575":"f93d2cf5","579":"3728c2c3","763":"f613ffb3","976":"8edd94b2"}[chunkId] + ".chunk.css";
};